import { CloudActions } from '@portal/portal-core';
import { call, debounce, put } from 'redux-saga/effects';

import { searchLicensesFailure, searchLicensesSuccess } from '../actions';
import type { SuperClientConfig, WrapResult } from '../api';
import { sendAction } from '../api';

// The dispatched search action itself carries the full request payload (searchString,
// costCenterType, productNames, limit, offset) — unlike the legacy users-search saga, which
// pulls a single filter string from shared redux state, this action is the request, so it's
// forwarded to sendAction as-is rather than reconstructed.
interface SearchLicensesAction {
  type: string;
  searchString: string;
  costCenterType?: string;
  productNames?: string[];
  limit?: number;
  offset?: number;
  requestId: string;
}

// The debounce effect forks one worker per accepted action and never cancels an in-flight one, so
// responses can land out of order. Each response carries its request's `requestId` and the
// reducer drops any that is not the latest request.
export function* searchLicenses(
  config: SuperClientConfig,
  action: SearchLicensesAction,
): Generator<unknown, void, unknown> {
  try {
    const res = (yield call(sendAction, config, action)) as WrapResult;
    if (res.succeeded) {
      yield put(searchLicensesSuccess(
        res.data as Parameters<typeof searchLicensesSuccess>[0],
        action.requestId,
      ));
    } else {
      throw new Error('response failed');
    }
  } catch (error) {
    console.error('Search Licenses -- ', error);
    yield put(searchLicensesFailure((error as Error).message, action.requestId));
  }
}

/* istanbul ignore next reason: no saga watch tests */
export function* watchSearchLicenses(
  config: SuperClientConfig,
): Generator<unknown, void, unknown> {
  yield debounce(
    500,
    CloudActions.ADMIN_ELASTICSEARCH_COST_CENTERS_SEARCH,
    searchLicenses,
    config,
  );
}
